
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import AppContextMenuOption from '@/components/AppContextMenuOption.vue'

@Component({
    components: {
        AppContextMenuOption,
    },
})

export default class AppContextMenu extends Vue {
    @Prop() private left!: number
    @Prop() private top!: number
    @Prop() private options!: ContextMenuOptionEntity[]

    get leftPosition() {
        return this.left + 'px'
    }

    get topPosition() {
        return this.top + 'px'
    }

    public mounted() {
        document.onmouseup = this.checkClickOutside
    }

    public checkClickOutside(e: any) {
        if (!this.$el.contains(e.target)) {
            document.onmouseup = null

            this.$emit('click', '')
        }
    }

    public onClickOption(value: string) {
        this.$emit('click', value)
    }
}
